// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__kJr72","left":"StickyBox_left__1NssN","right":"StickyBox_right__3he1X"};